import React, { useEffect } from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdjust, faDumbbell } from '@fortawesome/free-solid-svg-icons';
import PersonalRecordService from './personal-records/PersonalRecordService';
import { useState } from 'react';
const uniqueFilter = (value, index, self) => {
  return self.findIndex(v => v.type === value.type) === index;
};
const PersonalRecordsCard = () => {
  const [records, setRecords] = useState();
  useEffect(() => {
    PersonalRecordService.retrieveAllPersonalRecordsByUser()
      .then(data => {
        const uniqueRecords = data.filter(uniqueFilter); // To get only unique records based on the 'type' property
        console.log('Personal Records:', data);
        const updatedRecords = uniqueRecords.map(record => ({
          ...record,
          id: record.identifier,
          name: record.type, 
          previous: record.previousValue ? record.previousValue : 'N/A',
          trend: "up",
          improvement: record.previousValue && record.value ? (record.value / record.previousValue > 1 ? "+" + ((record.value / record.previousValue - 1) * 100).toFixed(2) + "%" : "-" + ((1 - record.value / record.previousValue) * 100).toFixed(2) + "%") : "N/A",
          date: new Date(record.date).toISOString()
        }));
        setRecords(updatedRecords);
      })
      .catch(error => {
        console.error('Error retrieving Personal Records', error);
      });
  }, []);

  return (
    <Card className="h-100 border-0 shadow-sm wod-dark-card">
      <Card.Header className="bg-transparent border-bottom border-secondary">
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon={faDumbbell} className="text-warning me-2" />
          <h5 className="mb-0 fw-bold">Personal Records</h5>
        </div>
      </Card.Header>
      <Card.Body>
        {records && records.length === 0 && (
          <div className="text-center p-3 text-white-50">
            No personal records to show.
          </div>
        )}
        <Row className="g-3">
          {records?.map((record) => (
            <Col xs={6} key={record.id}>
              <div
                className="p-3 rounded h-100"
                style={{
                  backgroundColor: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              >
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <small className="text-white-50">{record.name}</small>
                  {record.trend === 'up' && (
                    <Badge bg="success" className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faDumbbell} className="me-1" size="xs" />
                      {record.improvement}
                    </Badge>
                  )}
                </div>
                <div className="fs-4 fw-bold text-warning mb-1">{record.value}</div>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-white-50">
                    Previous: {record.previous}
                  </small>
                </div>
                <small className="text-white-50 d-block mt-1">
                  {new Date(record.date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric'
                  })}
                </small>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
      <Card.Footer className="bg-transparent border-top border-secondary text-center">
        <a href="/app/wod/personal-records" className="text-warning text-decoration-none">
          View All PRs →
        </a>
      </Card.Footer>
    </Card>
  );
};

export default PersonalRecordsCard;
